export const checkIfFeatureFlagsAreEnabled = (
  flagsToCheck: string[],
  featureFlags: Record<string, boolean>,
  requireOnlyOneFlag: boolean = false,
): boolean => {
  const flagValues = flagsToCheck.map((featureFlag) => featureFlags[featureFlag]);
  const isFlagEnabled = (featureFlag: boolean) => !!featureFlag;
  return requireOnlyOneFlag ? flagValues.some(isFlagEnabled) : flagValues.every(isFlagEnabled);
};
